var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95425 13.3028L16.3103 20.8736C16.391 20.9272 16.4847 20.958 16.5815 20.9627C16.6783 20.9673 16.7745 20.9456 16.86 20.8998C16.9454 20.8541 17.0168 20.7861 17.0666 20.7029C17.1164 20.6198 17.1428 20.5247 17.1428 20.4278V5.28641C17.1428 5.18951 17.1164 5.09444 17.0666 5.01132C17.0168 4.9282 16.9454 4.86014 16.86 4.81441C16.7745 4.76867 16.6783 4.74696 16.5815 4.75159C16.4847 4.75622 16.391 4.78702 16.3103 4.8407L4.95425 12.4114C4.88088 12.4603 4.82072 12.5266 4.77912 12.6044C4.73751 12.6821 4.71574 12.7689 4.71574 12.8571C4.71574 12.9453 4.73751 13.0321 4.77912 13.1099C4.82072 13.1876 4.88088 13.2539 4.95425 13.3028Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationArrow);
export default __webpack_public_path__ + "static/media/paginationArrow.0528901a55113bf51bf7a74d3db0f643.svg";
export { ForwardRef as ReactComponent };